export default {
  title: 'Rendimiento de campañas recientes',
  recipients: '{{recipients}} destinatarios',
  error_messages: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
